import { Component, OnInit } from '@angular/core';
import { BaseCase } from '../../../basecase';
@Component({
  selector: 'app-qc-audit-manage-list',
  templateUrl: './qc-audit-manage-list.component.html',
  styleUrls: ['./qc-audit-manage-list.component.scss']
})
export class QcAuditManageListComponent implements OnInit {
  auditsearchValue:any;
  productShow:boolean = false;
  constructor(
    public baseService: BaseCase,
  ) {
    this.baseService.FixedSubmitBtn.configName = "approvalselectionmanagement";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "批量驳回";
    this.baseService.FixedSubmitBtn.type = 11;
   }

  ngOnInit() {
  }
    // 搜索条件
    serarEvent(e,type:string = 'type'){
    
    }
    // 下边列表显示
    arrowSee(){
      const that =this;
      that.productShow = true;
    }
    // 下拉列表隐藏
    arrowhide(){
      const that =this;
      that.productShow = false;
    }
}
